//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";


//--------------- EXPORTAÇÃO DO SERVIÇO LOAD COMPANIES ---------------//
// Responsável por requisitar à API as empresas existentes ao usuário
export default async function synchronizeProductsService(groupId, productId) {
    try {
        await api.post(`/grupos-produtos/${groupId}/produtos`, { produto_id: productId });
        toast.success("Produto adicionado ao grupo com sucesso");
        return true;
    } catch (error) {
        toast.error("Erro ao adicionar produto ao grupo");
        return false;
    }
}